import { APP_ZONES, NotificationTransactionStatus } from '@finxone-platform/shared/sys-config-types';
import { Observable, catchError, tap } from 'rxjs';
import { SetPaymentRequestSummary } from '../../../actions/notification.action';
import { NotificationModel } from '../../../services/account-service/account.type';
import { NotificationState } from '../../../state/notifications.state';
import { formatNameAsUrl } from '../../zone-url.utils';
import { NotificationActionResources } from '../notification-center-action.utils';

export function getPaymentRequestStatusNotificationDataAndRedirect(
  resources: NotificationActionResources,
): string {
  const notification = resources.store
    .selectSnapshot(NotificationState.getNotification)
    .notificationList.find((v) => v.novuId === resources.notificationId);
  if (notification) {
    resources.accountService
      .getPaymentRequestDetailsById(notification.payload['requestId'])
      .pipe(
        tap((response) => {
          resources.store.dispatch(new SetPaymentRequestSummary(response));
        }),
        catchError<unknown, Observable<boolean>>((_err) => {
          throw _err;
        }),
      )
      .subscribe();
    return createAndReturnUrl(notification);
  } else {
    console.error('Notification data not found');
    return '';
  }
}

function createAndReturnUrl(notification: NotificationModel): string {
  let url = '';
  if (notification.payload['status'] === NotificationTransactionStatus.PENDING) {
    url = `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/payment-summary-approvers-decision`;
  }
  if (notification.payload['status'] === NotificationTransactionStatus.APPROVED) {
    url = `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/request-approved`;
  }
  if (notification.payload['status'] === NotificationTransactionStatus.REJECTED) {
    url = `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/request-rejected`;
  }
  return url;
}
